<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17v4lcB/image/FC-9781398481954.jpg?1708094026107" alt="This image is the cover for the book When Humpty Asked For Help"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When Humpty Asked For Help
      </h1>
      <p class="bookDescription body article font2">
        <p>Humpty’s feelings are weighing him down, and the weight is becoming too heavy a burden for him to carry alone. Are his worries a true reflection of his life and friendships? Or is his mind playing tricks on him? Watch what happens as Humpty learns the tremendous value one simple step can have – asking for help when we need it the most.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Desnà O'Neill, Anna Johnston
      </h2>
      
      <p class="authorDescription body article">Desnà is a civil servant mum of three who lives in a small town in Northern Ireland. Her previously published work includes the much-loved children’s tale Little Mouse’s Big Ambition.  Along with her young family, Desnà has a great love for all things outdoors, and outside of writing can often be found exploring her way around the island on which she lives.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f69ea8e